import { Link } from "react-router-dom";

export default function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      <div className="container announcement-bar__inner">
        <span className="announcement-bar__item">THE COMPLETE IDENTITY SHIFT™ SYSTEM</span>
        <span className="announcement-bar__sep" aria-hidden="true">·</span>
        <span className="announcement-bar__item">3 Books + 4 Journals + Daily Practice Kit</span>
        <Link to="/identity-shift" className="announcement-bar__cta">
          Explore the Collection ($47) →
        </Link>
      </div>
    </div>
  );
}
